export function highlight(root: HTMLElement, query: string): void {
  const re = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const targets: Text[] = [];
  let node = walker.nextNode();
  while (node) {
    const t = node as Text;
    if (re.test(t.data)) targets.push(t);
    node = walker.nextNode();
  }
  for (const t of targets) {
    const frag = document.createDocumentFragment();
    let last = 0;
    t.data.replace(re, (match: string, offset: number) => {
      if (offset > last) frag.appendChild(document.createTextNode(t.data.slice(last, offset)));
      const mark = document.createElement('mark');
      mark.textContent = match;
      frag.appendChild(mark);
      last = offset + match.length;
      return match;
    });
    if (last < t.data.length) frag.appendChild(document.createTextNode(t.data.slice(last)));
    t.parentNode?.replaceChild(frag, t);
  }
}

export function formatTemplate(tpl: string, vars: Record<string, string>): string {
  return tpl.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k: string) => vars[k] ?? '');
}

export function getCategoryLabel(handle: string): string {
  if (handle === 'all') return '';
  const label = document.querySelector<HTMLElement>(`faq-filter-tab[handle="${handle}"] [data-tab-label]`);
  return label?.textContent?.trim() ?? handle;
}
